export default [
    {
        text: "Context Property",
        xmlType: "contextProperty"
    },
    {
        text: "Item Property",
        xmlType: "itemProperty"
    },
    {
        text: "Constant Value",
        xmlType: "constantValue"
    },
    {
        text: "User Property",
        xmlType: "userProperty"
    },
    {
        text: "Dynamic Property",
        xmlType: "dynamicProperty"
    },
    {
        text: "Item Id",
        xmlType: "itemId"
    },
    {
        text: "Current time (sec)",
        xmlType: "currentTimeSec"
    },
    {
        text: "Current time (millisec)",
        xmlType: "currentTimeMilliSec"
    },
    {
        text: "Input count",
        xmlType: "inputCount"
    },
    {
        text: "Event type",
        xmlType: "constantValue"
    }
]